const CATEGORY_COLORS = {
  Office: "#1976d2", // Strong blue
  Travel: "#0288d1", // Slightly lighter blue
  "Motor Expenses": "#5c6bc0", // Indigo
  "Meals & Entertainment": "#ff7043", // Orange/red
  Software: "#00bcd4", // Cyan
  Marketing: "#e91e63", // Pink
  Equipment: "#388e3c", // Green
  Phone: "#26c6da", // Aqua blue/green
  Internet: "#ffc107", // Amber/yellow
  "Phone & Internet": "#26c6da", // Aqua blue/green (combined)
  "Professional Services": "#7b1fa2", // Purple
  Subscriptions: "#8d6e63", // Brown
  Education: "#9c27b0", // Vivid purple
  "Home Office": "#26A69A", // Teal
  Insurance: "#1976d2", // Strong blue
  Pension: "#9575cd", // Lilac/purple
  "Bank & Payment Fees": "#757575", // Grey
  "Legal Fees": "#ab47bc", // Light purple
  "Revenue Payments": "#43a047", // Green
  Revenue: "#43a047", // Green (alias)
  "Client Expenses": "#ffa000", // Deep yellow
  Utilities: "#78909c", // Blue-grey
  "Small Benefit Exemption": "#4caf50", // Bright green (tax-free benefit!)
  Other: "#bdbdbd", // Grey
  Uncategorized: "#9e9e9e", // Lighter grey
};

export default CATEGORY_COLORS;
